import { Flex, Stack } from "@chakra-ui/react";

import COLOR from "../../../constant/COLOR";
import IMAGES from "../../../constant/IMAGES";
import formatLuna from "../../../utils/formatLuna";
import {
  ContainRow,
  GridZodiac,
  Text,
  Title,
  TitleZodiac,
  WrapperQr,
} from "../style";
const canchiImages = [
  IMAGES.z1,
  IMAGES.z2,
  IMAGES.z3,
  IMAGES.z4,
  IMAGES.z5,
  IMAGES.z6,
  IMAGES.z7,
  IMAGES.z8,
  IMAGES.z9,
  IMAGES.z10,
  IMAGES.z11,
  IMAGES.z12,
];
interface SectionProps {
  detailCalendar: any;
}
const Section2: React.FC<SectionProps> = ({ detailCalendar }) => {
  return (
    <Stack justifyContent="center" width="100%" gap="40px" mt="20px">
      <TitleZodiac>Giờ hoàng đạo</TitleZodiac>

      <Stack
        gap="24px"
        p="24px"
        borderRadius="24px"
        height="100%"
        justifyContent="space-between"
        bg="linear-gradient(180deg, #F4E0B0 0%, rgba(244, 224, 176, 0) 100%)"
      >
        <GridZodiac>
          {detailCalendar?.gioHoangDao.map((day: any, idx: any) => (
            <Stack key={idx} alignItems="center" justifyContent="center">
              <img
                src={canchiImages[day?.order - 1]}
                alt=""
                style={{ height: "auto", width: "80px" }}
              />
              <Title
                style={{
                  marginTop: "10px",
                  fontSize: "40px",
                  color: COLOR.primary900,
                }}
              >{`${formatLuna[day?.name.toLowerCase()]}`}</Title>
              <Text style={{ color: COLOR.gray800, fontSize: "30px" }}>
                {day?.start}:00 - {day?.end}:00
              </Text>
            </Stack>
          ))}
        </GridZodiac>
        <Stack
          sx={{ background: COLOR.primary500, width: "100%", height: "1px" }}
        />
        <Stack width="100%" alignItems="start" gap="24px">
          <ContainRow
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <Text style={{ color: COLOR.gray800, fontSize: "40px" }}>
              Giờ thọ tử:
            </Text>
            <Title style={{ color: COLOR.primary900 }}>
              {`${formatLuna[detailCalendar?.gioThoTu?.name?.toLowerCase()] || "---"}`}{" "}
              &#40;
              {detailCalendar?.gioThoTu?.start || "00"} : 00 -{" "}
              {detailCalendar?.gioThoTu?.end || "00"} : 00&#41;
            </Title>
          </ContainRow>
          <ContainRow
            style={{ justifyContent: "space-between", width: "100%" }}
          >
            <Text style={{ color: COLOR.gray800, fontSize: "40px" }}>
              Giờ sát chủ:
            </Text>
            <Title style={{ color: COLOR.primary900 }}>
              {`${formatLuna[detailCalendar?.gioSatChu?.name?.toLowerCase()] || "---"}`}{" "}
              &#40;
              {detailCalendar?.gioSatChu?.start || "00"} : 00 -{" "}
              {detailCalendar?.gioSatChu?.end || "00"} : 00&#41;
            </Title>
          </ContainRow>
        </Stack>
        <WrapperQr>
          <Flex alignItems="center" gap="10px">
            <img
              style={{ width: "40px", height: "40px" }}
              src={IMAGES.phone}
              alt=""
            />
            <Text
              style={{
                color: COLOR.accent500,
                fontWeight: 600,
                lineHeight: "66px",
                marginBottom: "30px",
              }}
            >
              1900 989 919
            </Text>
          </Flex>
          <img style={{ width: "200px" }} src={IMAGES.qr} alt="" />
        </WrapperQr>
      </Stack>
    </Stack>
  );
};

export default Section2;
